(function () {
  // Bug: cart-drawer express payment buttons (Shop Pay/PayPal/etc, injected
  // by Shopify's own SDK into .kp-cart-express) render broken/overlapping
  // specifically after navigating away from the PDP and back — but work
  // fine on a genuinely fresh load. That pattern points at the browser's
  // back-forward cache (bfcache): a "back" navigation can restore a frozen
  // snapshot of the page instead of re-running scripts, so the payment
  // SDK's iframes come back in whatever half-initialized state they were
  // frozen in and never get a real re-init. A resize nudge (see
  // openCartDrawer below) isn't enough to fix an iframe that's genuinely
  // broken internally — force a real reload so the SDK runs fresh.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) window.location.reload();
  });

  var form = document.getElementById('kp-form');
  var variantInput = document.getElementById('kp-variant-id');
  var atcBtn = document.getElementById('kp-atc');
  var colourLabel = document.getElementById('kp-selected-colour');
  var colourTag = document.getElementById('kp-colour-tag');
  var unlockHint = document.getElementById('kp-unlock-hint');
  var sizeHint = document.getElementById('kp-size-hint');
  var variantDataEl = document.getElementById('kp-variant-data');
  var addonDataEl = document.getElementById('kp-addon-data');
  var heroImg = document.getElementById('kp-hero-img');

  if (!form || !variantInput || !atcBtn || !variantDataEl) return;

  // Pristine copy of the express checkout buttons (Shop Pay/PayPal/etc,
  // {{ content_for_additional_checkout_buttons }}) captured at page load,
  // before anything has touched it. Shopify's payment-button SDK upgrades
  // these via custom elements on connectedCallback; re-inserting a fresh
  // clone on every drawer open (see openCartDrawer below) forces a genuine
  // re-init every time, instead of relying on whatever state the browser
  // happened to leave the DOM in (which is what broke after navigating away
  // and back — the buttons rendered stacked/oversized because their SDK
  // never got a clean re-init on the return visit).
  var expressEl = document.querySelector('.kp-cart-express');
  var expressPristineHTML = expressEl ? expressEl.innerHTML : null;

  var variants = JSON.parse(variantDataEl.textContent).variants;
  var addonRaw = addonDataEl ? JSON.parse(addonDataEl.textContent) : {};
  // Extra Cap: one $30 flat add-on, one size per chip. Backed by two Shopify
  // products under the hood (repurposed former standalone Kids Cap / Adult
  // Cap) but presented here as a single merged list of sizes.
  var extraCapVariants = addonRaw.extraCapVariants || [];

  var priceData = addonRaw.prices || {};
  var PRICES = {
    set: priceData.set || 69,
    extraCap: priceData.extraCap || 30,
    shipping: priceData.shipping || 10
  };

  function findExtraCapVariant(size) {
    return extraCapVariants.find(function (v) { return v.size === size; });
  }

  function getExtraCapQtyInCart(cart, variantId) {
    if (!cart || !cart.items) return 0;
    var item = cart.items.find(function (i) { return i.variant_id === variantId; });
    return item ? item.quantity : 0;
  }

  function cartHasExtraCap(cart) {
    if (!cart || !cart.items) return false;
    var ids = extraCapVariants.map(function (v) { return v.id; });
    return cart.items.some(function (i) { return ids.indexOf(i.variant_id) !== -1 && i.quantity > 0; });
  }

  // A chip tap NEVER writes to the cart directly, whether the Set is
  // already in the cart or not — it only adjusts pendingExtras, which is a
  // DELTA against whatever's actually live in the cart right now (0 when
  // there's no line yet, so pre-Set-in-cart this behaves exactly like an
  // absolute staged qty). The only place a real /cart/add.js or
  // /cart/change.js call happens is the "Add/Update Cart" button — see
  // commitPendingExtras. This used to short-circuit to an immediate write
  // once the Set was in cart, which committed silently with no visible
  // confirmation near the chip the customer just tapped.
  var pendingExtras = { 'Toddler (2–4 yrs)': 0, 'Youth (5–11 yrs)': 0, 'Adult (12+ yrs)': 0 };

  function extraBaselineQty(cart, size) {
    var v = findExtraCapVariant(size);
    if (!v) return 0;
    return getExtraCapQtyInCart(cart, v.id);
  }

  function pendingExtrasTotal() {
    var total = 0;
    SIZE_ORDER.forEach(function (size) { total += pendingExtras[size] || 0; });
    return total;
  }

  function anyPendingExtraChange() {
    return SIZE_ORDER.some(function (size) { return (pendingExtras[size] || 0) !== 0; });
  }

  function resetPendingExtras() {
    SIZE_ORDER.forEach(function (size) { pendingExtras[size] = 0; });
  }

  // skipRender: the drawer path immediately follows this call with
  // commitPendingExtras, which does its own optimistic renderCart — without
  // this flag every drawer tap tore down and rebuilt the entire cart body +
  // module TWICE in a row (once here, once there) for the exact same
  // resulting numbers, which is what made rapid tapping feel laggy/
  // unresponsive (each full innerHTML rebuild is real DOM/layout work,
  // doubled for nothing). The PDP module and the "locked chip" bank-the-tap
  // path both still need this render — they don't call commit right after.
  function changePendingExtraQty(size, delta, skipRender) {
    if (!size) return;
    var baseline = extraBaselineQty(lastCart, size);
    var newDelta = Math.max(-baseline, (pendingExtras[size] || 0) + delta);
    pendingExtras[size] = newDelta;
    if (typeof gtag === 'function') {
      gtag('event', delta > 0 ? 'addon_chip_tap' : 'addon_removed', { event_category: 'ecommerce', value: baseline + newDelta });
    }
    if (skipRender) return;
    renderCart(lastCart);
    // updateCTA (not just updateAddonCtas) so the top "Add Set to Cart"
    // button's label picks up the new staged total immediately — see the
    // netExtra branch in updateCTA.
    updateCTA();
  }

  // Single button, both mount points ("Add N Caps to Cart" pre-Set-in-cart,
  // since this button adds the Set itself too, not just the extras; "Add
  // Extra Cap(s) to Cart" / "Update Cart" once the Set's already in the
  // cart, since the top ATC has become "View Cart" by then).
  function xcapCtaLabel() {
    var net = pendingExtrasTotal();
    if (!setInCart) return 'Add ' + (2 + net) + ' Caps to Cart';
    if (net > 0) return 'Add Extra Cap' + (net > 1 ? 's' : '') + ' to Cart';
    return 'Update Cart';
  }

  function xcapShowCta() {
    if (!anyPendingExtraChange()) return false;
    if (!setInCart) return !!selectedSize;
    return true;
  }

  function setXcapCtaBusy(busy) {
    document.querySelectorAll('.kp-xcap-set-cta').forEach(function (btn) {
      btn.disabled = busy;
      btn.classList.toggle('is-adding', busy);
    });
  }

  // Commits every staged delta once the Set is already in the cart — the
  // one place left where the module actually writes to /cart. Sizes with
  // no existing line are batched into a single /cart/add.js call; sizes
  // that already have a line go through /cart/change.js one at a time.
  // IMPORTANT: /cart/change.js's "id" must be the real line *key* (format
  // "variantId:propertiesHash") or a 1-based line index — a bare variant
  // ID is silently reinterpreted as a line index and 400s the moment the
  // cart has more than that many lines.

  // Applies `changes` to a cloned cart for an immediate, optimistic render
  // — the cart list should update the instant the CTA is tapped, not after
  // the add/change/reconcile round-trip resolves. Confirmed (or rolled
  // back) once the real request finishes.
  function buildOptimisticCart(baseCart, changes) {
    var cart = baseCart ? JSON.parse(JSON.stringify(baseCart)) : { items: [], item_count: 0, total_price: 0 };
    changes.forEach(function (c) {
      var idx = cart.items.findIndex(function (i) { return i.variant_id === c.variantId; });
      if (idx === -1) {
        if (c.newQty <= 0) return;
        var isAdultAddon = c.size === 'Adult (12+ yrs)';
        var linePrice = PRICES.extraCap * 100 * c.newQty;
        var optimisticItem = {
          product_title: isAdultAddon ? 'Extra Cap — Adult Size' : 'Extra Cap — Kids Sizes',
          variant_title: isAdultAddon ? 'Navy' : ('Navy / ' + c.size),
          quantity: c.newQty,
          price: PRICES.extraCap * 100,
          final_line_price: linePrice,
          line_price: linePrice,
          key: 'optimistic-' + c.variantId,
          variant_id: c.variantId,
          image: null
        };
        cart.items.push(optimisticItem);
        cart.item_count = (cart.item_count || 0) + c.newQty;
        cart.total_price = (cart.total_price || 0) + linePrice;
      } else {
        var item = cart.items[idx];
        var oldQty = item.quantity;
        var diff = c.newQty - oldQty;
        if (c.newQty <= 0) {
          cart.items.splice(idx, 1);
          cart.item_count -= oldQty;
          cart.total_price -= item.price * oldQty;
        } else {
          item.quantity = c.newQty;
          item.line_price = item.price * c.newQty;
          item.final_line_price = item.price * c.newQty;
          cart.item_count += diff;
          cart.total_price += item.price * diff;
        }
      }
    });
    return cart;
  }

  function commitPendingExtras(context) {
    if (cartMutating || !anyPendingExtraChange()) return;

    var changes = SIZE_ORDER.map(function (size) {
      var delta = pendingExtras[size] || 0;
      if (!delta) return null;
      var v = findExtraCapVariant(size);
      if (!v) return null;
      var baseline = extraBaselineQty(lastCart, size);
      return { size: size, variantId: v.id, baseline: baseline, newQty: Math.max(0, baseline + delta) };
    }).filter(Boolean);
    if (!changes.length) return;

    var netDelta = pendingExtrasTotal();
    var hadExtraBefore = cartHasExtraCap(lastCart);
    var toAdd = changes.filter(function (c) { return c.baseline === 0 && c.newQty > 0; });
    var toChange = changes.filter(function (c) { return c.baseline > 0; });

    // Clear the staged deltas now, before the optimistic render — the
    // optimistic cart built below already bakes `changes` into its
    // baseline, so leaving pendingExtras non-zero here double-counts them
    // (chip briefly shows baseline+delta+pendingExtras, e.g. 0 -> 2 for a
    // single tap, before snapping back to the correct 1 once the real
    // commit resolves and used to reset it). Restored on failure below.
    resetPendingExtras();

    // Instant feedback — render the guessed end-state right away, before
    // any network call has even fired.
    var optimisticCart = buildOptimisticCart(lastCart, changes);
    lastCart = optimisticCart;
    applyCartState(optimisticCart);
    renderCart(optimisticCart);

    cartMutating = true;
    setXcapCtaBusy(true);

    var chain = Promise.resolve();

    if (toAdd.length) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: toAdd.map(function (c) { return { id: c.variantId, quantity: c.newQty }; }) })
        }).then(function (res) {
          if (res.ok) return res.json();
          return res.json().then(function (data) { throw new Error(data.description || data.message || 'Could not add to cart.'); });
        });
      });
    }

    toChange.forEach(function (c) {
      chain = chain.then(function () {
        // Re-fetch right before each change — an earlier add in this same
        // batch can shift what the real line key is.
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          lastCart = cart;
          var line = cart.items.find(function (i) { return i.variant_id === c.variantId; });
          if (!line) return null;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: c.newQty })
          }).then(function (res) { return res.json(); });
        });
      });
    });

    chain
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        cartMutating = false;
        setXcapCtaBusy(false);
        if (typeof gtag === 'function') {
          gtag('event', netDelta > 0 ? 'addon_chip_tap' : 'addon_removed', { event_category: 'ecommerce', value: netDelta });
          if (netDelta > 0 && !hadExtraBefore) gtag('event', 'free_shipping_unlocked', { event_category: 'ecommerce' });
        }
        lastCart = cart;
        applyCartState(cart);
        // From the PDP, show the same drawer the "Add Set to Cart" flow
        // opens — otherwise the only feedback is the bag count changing,
        // easy to miss. The drawer's own taps are already looking at an
        // open drawer, so just re-render in place there.
        if (context === 'pdp') openCartDrawer(cart);
        else renderCart(cart);
        // Taps are never blocked by cartMutating while a commit is in
        // flight (see the click handlers) — a rapid tapper can stage more
        // addon changes, or queue cart-line qty/remove taps, during this
        // exact window. Flush whichever is pending now instead of leaving
        // it stuck with nothing left to trigger a commit.
        flushPendingCartWork(context);
      })
      .catch(function (err) {
        cartMutating = false;
        setXcapCtaBusy(false);
        showDrawerError(err && err.message ? err.message : 'Could not update cart — please try again.');
        // Restore the staged deltas we cleared before the optimistic
        // render, so the chips still show what they tapped rather than
        // silently losing it.
        changes.forEach(function (c) { pendingExtras[c.size] = c.newQty - c.baseline; });
        // lastCart is currently the optimistic guess, not confirmed real
        // state — roll back to the real cart.
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
          lastCart = real;
          applyCartState(real);
          renderCart(real);
          flushPendingCartWork(context);
        });
      });
  }

  // Cart-line qty (+/-) and remove taps share this queue, and share the
  // same cartMutating lock with commitPendingExtras above — /cart writes
  // aren't safe to fire concurrently, so only one mutation is ever truly
  // in flight. What used to happen on a rapid tap was that every tap
  // landing while cartMutating was true got silently dropped (no visual
  // response at all). Now the optimistic UI update always applies
  // instantly, and the *commit* is queued instead of dropped: queued
  // taps get coalesced to a line's latest desired quantity and flushed by
  // flushPendingCartWork the moment the in-flight request resolves.
  var pendingQtyByKey = {};

  function queueQtyCommit(key, targetQty) {
    pendingQtyByKey[key] = targetQty;
    if (!cartMutating) runNextQtyCommit();
  }

  function runNextQtyCommit() {
    var keys = Object.keys(pendingQtyByKey);
    if (!keys.length) return;
    var key = keys[0];
    var targetQty = pendingQtyByKey[key];
    delete pendingQtyByKey[key];
    cartMutating = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: targetQty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      cartMutating = false;
      // A bad/stale line key comes back as an error object, not a cart (no
      // .items) — never render that as if it were a real, empty cart.
      if (!cart || !cart.items) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
          lastCart = real; applyCartState(real); renderCart(real);
          showDrawerError('Could not update cart — please try again.');
          flushPendingCartWork();
        });
        return;
      }
      lastCart = cart;
      applyCartState(cart);
      renderCart(cart);
      flushPendingCartWork();
    }).catch(function () {
      cartMutating = false;
      flushPendingCartWork();
    });
  }

  // Single drain point called at the end of every cart mutation — checks
  // the qty/remove queue first, then staged addon extras, and fires
  // whichever is pending. Cart-line qty controls only ever render inside
  // the drawer (there's one #kp-cart-body in the DOM), so 'drawer' is
  // always the right context for a commitPendingExtras call triggered from
  // here.
  function flushPendingCartWork(context) {
    if (Object.keys(pendingQtyByKey).length) { runNextQtyCommit(); return; }
    if (anyPendingExtraChange()) commitPendingExtras(context || 'drawer');
  }

  var activeSwatch = document.querySelector('.kp-sw.is-active');
  var defaultColourInput = document.getElementById('kp-default-colour');
  var selectedColour = activeSwatch ? activeSwatch.dataset.colour : (defaultColourInput ? defaultColourInput.value : 'Navy');
  var selectedSize = null;

  var addonState = {
    kids:  { open: false, confirmed: false, size: null },
    adult: { open: false, confirmed: false },
    set2:  { open: false, confirmed: false, size: null, colour: null }
  };

  var setInCart = false;
  var bundleTimer = null;
  var drawerUpsellState = { kids: { size: null, colour: null, done: false, open: true }, adult: { colour: null, done: false }, set: { size: null, colour: null, done: false, open: false } };
  var lastCart = null;
  var savingsTimer = null;
  var cartMutating = false;

  function findSetVariant(colour, size) {
    return variants.find(function (v) {
      return v.option1 === colour && v.option2 === size;
    });
  }

  function findKidsCapVariant(colour, size) {
    return kidsCapVariants.find(function (v) {
      return v.colour === colour && v.size === size;
    });
  }

  function findAdultCapVariant(colour) {
    return adultCapVariants.find(function (v) {
      return v.colour === colour;
    });
  }

  function resolveKidsAddonVariant(colour, size) {
    if (size === 'Adult (12+ yrs)') return findAdultCapVariant(colour);
    return findKidsCapVariant(colour, size);
  }

  function calcTotal() {
    // Extra Caps are added as independent real cart lines via the stepper
    // module, not merged into the Set's own Add to Cart price.
    return PRICES.set;
  }

  // Triggered by either clicking "Add Set to Cart" with no size chosen, or
  // tapping a locked chip down in "Make it more than two" — either way the
  // thing they need to do is the SECOND CAP SIZE chips, and this points at
  // them unmistakably: a dimmed backdrop, the chips lit up above it, and a
  // label right there saying what to do. It stays up until they actually
  // pick a size (dismissSizeSpotlight is called from that chip's own click
  // handler) or dismiss it themselves by clicking outside — no auto-timeout,
  // since the whole point is holding attention until the real action happens.
  // Triggered only once the chips are actually on screen (via
  // IntersectionObserver) so it can't race the scroll like a fixed-duration
  // animation would.
  function spotlightSecondCapSize() {
    var chipsEl = document.querySelector('.kp-opt-block .kp-chips');
    if (!chipsEl) return;

    var overlay = document.getElementById('kp-size-spotlight-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'kp-size-spotlight-overlay';
      overlay.className = 'kp-size-spotlight-overlay';
      overlay.addEventListener('click', dismissSizeSpotlight);
      document.body.appendChild(overlay);
    }

    var label = document.getElementById('kp-size-spotlight-label');
    if (!label) {
      label = document.createElement('div');
      label.id = 'kp-size-spotlight-label';
      label.className = 'kp-size-spotlight-label';
      label.textContent = 'Choose their size here first';
      chipsEl.parentElement.insertBefore(label, chipsEl);
    }

    function reveal() {
      overlay.classList.add('is-active');
      chipsEl.classList.add('kp-chips--spotlight');
      label.classList.add('is-visible');
    }

    chipsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          reveal();
          obs.disconnect();
        }
      }, { threshold: 0.8 });
      obs.observe(chipsEl);
    } else {
      reveal();
    }
  }

  function dismissSizeSpotlight() {
    var overlay = document.getElementById('kp-size-spotlight-overlay');
    var label = document.getElementById('kp-size-spotlight-label');
    var chipsEl = document.querySelector('.kp-opt-block .kp-chips');
    if (overlay) overlay.classList.remove('is-active');
    if (label) label.classList.remove('is-visible');
    if (chipsEl) chipsEl.classList.remove('kp-chips--spotlight');
  }

  // Conceptually the same trick as spotlightSecondCapSize/dismissSizeSpotlight
  // above (dim + lift + persistent label), but NOT the same DOM/CSS classes —
  // that version's overlay is position:fixed at a low z-index, meant to dim
  // the whole page around page-level chips. Inside the cart drawer (itself
  // fixed-position at z-index:901), that overlay would render invisibly
  // behind the drawer. This version's overlay instead dims the rest of the
  // DRAWER's own content, appended inside #kp-cart-drawer itself so it only
  // ever needs to out-rank its drawer siblings, not the page's global
  // z-index stack. Triggered by tapping the grey/locked free-shipping badge
  // (drawer only for now). #kp-cart-addon-mount is always the drawer's
  // module — only one drawer is ever open at a time, so no need to scope
  // from the clicked badge itself.
  // Badge is now interactive in both mounts (Daniel's ask — the PDP one
  // used to stay a plain <span>). The drawer is itself a fixed-position
  // overlay (z-index:901), so its spotlight overlay has to be appended
  // INSIDE the drawer to out-rank drawer siblings (see the comment above
  // this block, pre-existing). The PDP module sits in normal page flow, so
  // its spotlight instead reuses the exact page-level fixed-overlay pattern
  // already built for spotlightSecondCapSize (scrollIntoView + gate the
  // reveal on IntersectionObserver so it can't race the scroll).
  function spotlightXcapChips(context) {
    if (context === 'drawer') {
      var drawer = document.getElementById('kp-cart-drawer');
      var chipsEl = document.querySelector('#kp-cart-addon-mount .kp-xcap-chips');
      if (!drawer || !chipsEl) return;

      var overlay = document.getElementById('kp-xcap-spotlight-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'kp-xcap-spotlight-overlay';
        overlay.className = 'kp-xcap-spotlight-overlay';
        overlay.addEventListener('click', function () { dismissXcapSpotlight('drawer'); });
        drawer.appendChild(overlay);
      }

      var label = document.getElementById('kp-xcap-spotlight-label');
      if (!label) {
        label = document.createElement('div');
        label.id = 'kp-xcap-spotlight-label';
        // position:absolute (see CSS), appended inside .kp-xcap-chips itself
        // so it never occupies layout space and can't eat into the module's
        // carefully-budgeted flex-shrink split.
        label.className = 'kp-xcap-spotlight-label';
        label.textContent = 'Choose an extra cap for free shipping';
        chipsEl.appendChild(label);
      }

      // Already on screen inside an open drawer — no scrollIntoView/
      // IntersectionObserver gating needed like the page-scroll version.
      overlay.classList.add('is-active');
      chipsEl.classList.add('kp-xcap-chips--spotlight');
      label.classList.add('is-visible');
      return;
    }

    // PDP: page-level fixed overlay, separate DOM nodes from the drawer's
    // (both can technically exist in the DOM at once — one open drawer max,
    // but the PDP module is always present underneath it), so distinct ids.
    var pdpChipsEl = document.querySelector('#kp-addon-module-mount .kp-xcap-chips');
    if (!pdpChipsEl) return;

    var pdpOverlay = document.getElementById('kp-xcap-page-spotlight-overlay');
    if (!pdpOverlay) {
      pdpOverlay = document.createElement('div');
      pdpOverlay.id = 'kp-xcap-page-spotlight-overlay';
      // Reuses .kp-size-spotlight-overlay's fixed/dim/z-index:40 styling —
      // same "dim the whole page" job as spotlightSecondCapSize's overlay,
      // just a different trigger.
      pdpOverlay.className = 'kp-size-spotlight-overlay';
      pdpOverlay.addEventListener('click', function () { dismissXcapSpotlight('pdp'); });
      document.body.appendChild(pdpOverlay);
    }

    var pdpLabel = document.getElementById('kp-xcap-page-spotlight-label');
    if (!pdpLabel) {
      pdpLabel = document.createElement('div');
      pdpLabel.id = 'kp-xcap-page-spotlight-label';
      pdpLabel.className = 'kp-xcap-spotlight-label';
      pdpLabel.textContent = 'Choose an extra cap for free shipping';
      pdpChipsEl.appendChild(pdpLabel);
    }

    function reveal() {
      pdpOverlay.classList.add('is-active');
      pdpChipsEl.classList.add('kp-xcap-chips--spotlight');
      pdpLabel.classList.add('is-visible');
    }

    pdpChipsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          reveal();
          obs.disconnect();
        }
      }, { threshold: 0.8 });
      obs.observe(pdpChipsEl);
    } else {
      reveal();
    }
  }

  function dismissXcapSpotlight(context) {
    if (context === 'pdp') {
      var pdpOverlay = document.getElementById('kp-xcap-page-spotlight-overlay');
      var pdpLabel = document.getElementById('kp-xcap-page-spotlight-label');
      var pdpChipsEl = document.querySelector('#kp-addon-module-mount .kp-xcap-chips');
      if (pdpOverlay) pdpOverlay.classList.remove('is-active');
      if (pdpLabel) pdpLabel.classList.remove('is-visible');
      if (pdpChipsEl) pdpChipsEl.classList.remove('kp-xcap-chips--spotlight');
      return;
    }
    if (context === 'drawer') {
      var overlay = document.getElementById('kp-xcap-spotlight-overlay');
      var label = document.getElementById('kp-xcap-spotlight-label');
      var chipsEl = document.querySelector('#kp-cart-addon-mount .kp-xcap-chips');
      if (overlay) overlay.classList.remove('is-active');
      if (label) label.classList.remove('is-visible');
      if (chipsEl) chipsEl.classList.remove('kp-xcap-chips--spotlight');
      return;
    }
    // No context (e.g. called from syncFreeShipBadges on unlock) — clear both.
    dismissXcapSpotlight('drawer');
    dismissXcapSpotlight('pdp');
  }

  // Confirm box tracks selection STATE: it shows only while the pair is
  // complete-and-orderable, and hides again the moment the second cap is
  // deselected / becomes unavailable / the set is already in cart. (Before,
  // it latched on once shown and never left — Daniel spotted it staying up
  // after unselecting the size.)
  function hideSizeConfirm() {
    var el = document.getElementById('kp-size-confirm');
    if (el) { el.classList.remove('is-visible'); el.setAttribute('aria-hidden', 'true'); }
    // stop the ATC "ready" breathe once a valid second cap is no longer selected
    [atcBtn, document.getElementById('kp-sticky-cta')].forEach(function (btn) { if (btn) btn.classList.remove('kp-atc--pulse'); });
  }

  function updateCTA() {
    if (setInCart) {
      atcBtn.disabled = false;
      atcBtn.setAttribute('aria-disabled', 'false');
      atcBtn.textContent = 'View Cart';
      hideSizeConfirm();
      atcBtn.classList.add('kp-atc--view-cart');
      if (unlockHint) unlockHint.classList.add('is-hidden');
      toggleCtaHelper(false);
      syncStickyCta();
      updateAddonCtas();
      return;
    }
    atcBtn.classList.remove('kp-atc--view-cart');
    if (!selectedSize) {
      atcBtn.disabled = false;
      atcBtn.setAttribute('aria-disabled', 'true');
      atcBtn.textContent = 'Add Set to Cart';
      variantInput.value = '';
      hideSizeConfirm();
      if (unlockHint) unlockHint.classList.remove('is-hidden');
      syncStickyCta();
      updateAddonCtas();
      return;
    }
    var variant = findSetVariant(selectedColour, selectedSize);
    if (!variant) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-disabled', 'true');
      atcBtn.textContent = 'Unavailable';
      variantInput.value = '';
      hideSizeConfirm();
      toggleCtaHelper(false);
      syncStickyCta();
      updateAddonCtas();
      return;
    }
    variantInput.value = String(variant.id);
    atcBtn.disabled = false;
    atcBtn.setAttribute('aria-disabled', 'false');
    // Submitting this button already batches the Set plus every staged
    // extra into one /cart/add.js call (see submitMainForm) — the label
    // should say so, rather than read "Add Set to Cart" while quietly
    // adding 3+ caps.
    var netExtra = pendingExtrasTotal();
    atcBtn.textContent = netExtra > 0 ? 'Add ' + (2 + netExtra) + ' Caps to Cart' : 'Add Set to Cart';
    if (unlockHint) unlockHint.classList.add('is-hidden');
    toggleCtaHelper(false);
    var confirmEl = document.getElementById('kp-size-confirm');
    if (confirmEl && !confirmEl.classList.contains('is-visible')) {
      confirmEl.classList.add('is-visible');
      confirmEl.removeAttribute('aria-hidden');
      [atcBtn, document.getElementById('kp-sticky-cta')].forEach(function(btn) {
        if (!btn) return;
        btn.classList.remove('kp-atc--pulse');
        void btn.offsetWidth;
        btn.classList.add('kp-atc--pulse');
      });
    }
    syncStickyCta();
    updateAddonCtas();
  }

  function checkBundle() {
    if (!addonState.kids.confirmed || !addonState.adult.confirmed) return;

    var kidsSize = addonState.kids.size;

    addonState.kids.confirmed = false;
    addonState.kids.open = false;
    addonState.kids.size = null;
    var kidsBox = document.getElementById('kp-addon-box-kids');
    if (kidsBox) kidsBox.classList.remove('is-open', 'is-active');
    var kidsTrigger = document.querySelector('[data-addon="kids"]');
    if (kidsTrigger) kidsTrigger.setAttribute('aria-expanded', 'false');
    document.querySelectorAll('[data-addon-type="kids"]').forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-pressed', 'false');
    });

    addonState.adult.confirmed = false;
    addonState.adult.open = false;
    var adultBox = document.getElementById('kp-addon-box-adult');
    if (adultBox) adultBox.classList.remove('is-open', 'is-active');
    var adultTrigger = document.querySelector('[data-addon="adult"]');
    if (adultTrigger) adultTrigger.setAttribute('aria-expanded', 'false');

    addonState.set2.open = true;
    addonState.set2.size = kidsSize;
    addonState.set2.confirmed = !!kidsSize;
    var set2Box = document.getElementById('kp-addon-box-set2');
    if (set2Box) {
      set2Box.classList.add('is-open');
      if (kidsSize) set2Box.classList.add('is-active');
    }
    var set2Trigger = document.querySelector('[data-addon="set2"]');
    if (set2Trigger) set2Trigger.setAttribute('aria-expanded', 'true');

    document.querySelectorAll('[data-addon-type="set2"]').forEach(function (c) {
      var match = kidsSize && c.dataset.addonSize === kidsSize;
      c.classList.toggle('is-active', match);
      c.setAttribute('aria-pressed', String(match));
    });

    if (set2Box) set2Box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    if (setInCart) updateStandaloneBtn('set2');
  }

  document.querySelectorAll('.kp-sw').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.kp-sw').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      selectedColour = btn.dataset.colour;
      if (colourLabel) colourLabel.textContent = selectedColour;
      if (colourTag) colourTag.textContent = selectedColour;
      filterGallery(selectedColour);
      syncAddonColours();
      updateAddonColourDisplay(selectedColour);
      updateCTA();
      if (window.innerWidth < 768) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  });

  function getColourImage(colour) {
    var handle = (colour || '').toLowerCase();
    var thumbs = document.querySelectorAll('.kp-thumb');
    for (var i = 0; i < thumbs.length; i++) {
      var tc = (thumbs[i].dataset.colour || '').toLowerCase();
      if (tc === handle && thumbs[i].dataset.full) return thumbs[i].dataset.full;
    }
    return null;
  }

  function updateAddonColourDisplay(colour) {
    var handle = (colour || '').toLowerCase();
    ['kids', 'adult'].forEach(function (key) {
      var dot  = document.getElementById('kp-addon-colour-dot-' + key);
      var note = document.getElementById('kp-addon-colour-note-' + key);
      if (dot)  dot.className = 'kp-sw-dot kp-sw-dot--' + handle + ' kp-addon-dot';
      if (note) note.textContent = (colour || '') + ' — matches your set';
    });
  }

  function filterGallery(colour) {
    var handle = colour ? colour.toLowerCase() : '';
    var thumbs = document.querySelectorAll('.kp-thumb');
    var firstVisible = null;
    var visibleCount = 0;
    thumbs.forEach(function (thumb) {
      var tc = (thumb.dataset.colour || '').toLowerCase();
      var match = tc === '' || tc === handle || tc.indexOf(handle) !== -1;
      thumb.hidden = !match;
      if (match) {
        visibleCount++;
        if (!firstVisible) firstVisible = thumb;
      }
    });
    var thumbsEl = document.querySelector('.kp-thumbs');
    if (thumbsEl) thumbsEl.classList.toggle('kp-thumbs--spread', visibleCount >= 5);
    if (firstVisible && heroImg) {
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      firstVisible.classList.add('is-active');
      heroImg.srcset = '';
      heroImg.src = firstVisible.dataset.full;
    }
  }

  if (selectedColour) filterGallery(selectedColour);
  updateAddonColourDisplay(selectedColour);

  function setSet2ColourVal(colour) {
    var el = document.getElementById('kp-set2-colour-val');
    if (el) el.textContent = colour;
  }

  function syncAddonColours() {
    if (!selectedColour) return;
    if (!addonState.set2.colour) {
      document.querySelectorAll('.kp-set2-sw').forEach(function (btn) {
        var match = btn.dataset.colour === selectedColour;
        btn.classList.toggle('is-active', match);
        btn.setAttribute('aria-pressed', String(match));
      });
      setSet2ColourVal(selectedColour);
    }
  }

  document.querySelectorAll('.kp-set2-sw').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.kp-set2-sw').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      addonState.set2.colour = btn.dataset.colour;
      setSet2ColourVal(btn.dataset.colour);
      filterGallery(btn.dataset.colour);
    });
  });

  document.querySelectorAll('.kp-chip:not([data-addon-type])').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isActive = btn.classList.contains('is-active');
      document.querySelectorAll('.kp-chip:not([data-addon-type])').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      if (!isActive) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        selectedSize = btn.dataset.size;
        if (typeof gtag === 'function') gtag('event', 'size_selected', { event_category: 'product', event_label: btn.dataset.size });
        dismissSizeSpotlight();
      } else {
        selectedSize = null;
      }
      updateCTA();
      renderPdpAddonMount(lastCart);
    });
  });

  document.querySelectorAll('.kp-addon-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var type  = btn.dataset.addon;
      var state = addonState[type];
      var box   = document.getElementById('kp-addon-box-' + type);
      if (!box) return;

      if (state.open) {
        if ('size' in state && !state.size) {
          var chipsEl = box.querySelector('.kp-addon-size-block .kp-chips');
          if (chipsEl) {
            chipsEl.classList.remove('kp-chips--shake');
            void chipsEl.offsetWidth;
            chipsEl.classList.add('kp-chips--shake');
            chipsEl.addEventListener('animationend', function () {
              chipsEl.classList.remove('kp-chips--shake');
            }, { once: true });
          }
          return;
        }
        if (bundleTimer) { clearTimeout(bundleTimer); bundleTimer = null; }
        state.open = false;
        state.confirmed = false;
        if ('size' in state) {
          state.size = null;
          document.querySelectorAll('[data-addon-type="' + type + '"]').forEach(function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-pressed', 'false');
          });
        }
        box.classList.remove('is-open', 'is-active');
        btn.setAttribute('aria-expanded', 'false');
        if (setInCart) updateStandaloneBtn(type);
      } else {
        state.open = true;
        box.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (type === 'adult') {
          state.confirmed = true;
          box.classList.add('is-active');
          if (setInCart) updateStandaloneBtn('adult');
          if (setInCart && addonState.kids.confirmed) {
            bundleTimer = setTimeout(function () {
              bundleTimer = null;
              checkBundle();
              updateCTA();
            }, 700);
          } else {
            checkBundle();
          }
        }
      }
      updateCTA();
    });
  });

  document.querySelectorAll('.kp-chip[data-addon-type]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var type  = btn.dataset.addonType;
      var size  = btn.dataset.addonSize;
      var state = addonState[type];
      var box   = document.getElementById('kp-addon-box-' + type);
      var isActive = btn.classList.contains('is-active');

      document.querySelectorAll('[data-addon-type="' + type + '"]').forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
      });

      if (!isActive) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        state.size = size;
        state.confirmed = true;
        if (box) box.classList.add('is-active');
        if (setInCart && addonState.adult.confirmed) {
          bundleTimer = setTimeout(function () {
            bundleTimer = null;
            checkBundle();
            updateCTA();
          }, 700);
        } else {
          checkBundle();
        }
      } else {
        if (bundleTimer) { clearTimeout(bundleTimer); bundleTimer = null; }
        state.size = null;
        state.confirmed = false;
        if (box) box.classList.remove('is-active');
      }
      if (setInCart) updateStandaloneBtn(type);
      updateCTA();
    });
  });

  function switchHero(btn) {
    document.querySelectorAll('.kp-thumb').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    if (heroImg && btn.dataset.full) { heroImg.srcset = ''; heroImg.src = btn.dataset.full; }
  }

  document.querySelectorAll('.kp-thumb').forEach(function (thumb) {
    if (thumb.dataset.full) { var pre = new Image(); pre.src = thumb.dataset.full; }
    var startX = 0, startY = 0, dragged = false, tapped = false;
    thumb.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; dragged = false;
    }, { passive: true });
    thumb.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) dragged = true;
    }, { passive: true });
    thumb.addEventListener('touchend', function (e) {
      if (dragged) return;
      e.preventDefault();
      tapped = true;
      switchHero(thumb);
    }, { passive: false });
    thumb.addEventListener('click', function () {
      if (tapped) { tapped = false; return; }
      switchHero(thumb);
    });
  });

  document.querySelectorAll('.kp-acc-head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var body = btn.nextElementSibling;
      btn.setAttribute('aria-expanded', String(!expanded));
      if (body) body.hidden = expanded;
    });
  });

  function openHashAccordion() {
    if (location.hash !== '#kp-inline-sg') return;
    var container = document.getElementById('kp-inline-sg');
    var head = container && container.querySelector('.kp-acc-head');
    var body = head && head.nextElementSibling;
    if (!head || !body) return;
    head.setAttribute('aria-expanded', 'true');
    body.hidden = false;
  }
  window.addEventListener('hashchange', openHashAccordion);
  openHashAccordion();

  function positionPopup(triggerEl, popup) {
    var rect = triggerEl.getBoundingClientRect();
    var margin = 10;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    popup.style.visibility = 'hidden';
    popup.classList.add('is-open');
    var pw = popup.offsetWidth;
    var ph = popup.offsetHeight;
    popup.style.visibility = '';
    var left = rect.right - pw;
    if (left < margin) left = margin;
    if (left + pw > vw - margin) left = vw - margin - pw;
    popup.style.left = left + 'px';
    popup.style.right = 'auto';
    if (vh - rect.bottom - margin >= ph) {
      popup.style.top = (rect.bottom + margin) + 'px';
    } else {
      popup.style.top = Math.max(margin, rect.top - ph - margin) + 'px';
    }
    popup.style.bottom = 'auto';
  }

  function shakeEl(el, shakeClass) {
    if (!el) return;
    shakeClass = shakeClass || 'kp-chips--shake';
    el.classList.remove(shakeClass);
    void el.offsetWidth;
    el.classList.add(shakeClass);
  }

  document.addEventListener('click', function (e) {
    var xcapBadgeBtn = e.target.closest ? e.target.closest('.kp-xcap-badge--interactive') : null;
    if (xcapBadgeBtn) {
      if (!xcapBadgeBtn.classList.contains('is-unlocked')) {
        var badgeModule = xcapBadgeBtn.closest('.kp-xcap');
        spotlightXcapChips(badgeModule ? badgeModule.dataset.xcapContext : 'pdp');
      }
      return;
    }

    var xcapBtn = e.target.closest ? e.target.closest('.kp-xcap-btn') : null;
    if (xcapBtn) {
      var xcapModule = xcapBtn.closest('.kp-xcap');
      if (xcapModule && xcapModule.dataset.xcapLocked === 'true') {
        // Bank the tap they already made — re-rendering below rebuilds this
        // DOM, so shake the current node first, then apply the intent, so
        // the chip already shows what they asked for the moment the module
        // unlocks instead of resetting to 0 and making them tap again.
        var lockedChipEl = xcapBtn.closest('.kp-xcap-chip');
        var lockedSize = lockedChipEl ? lockedChipEl.dataset.xcapSize : null;
        var lockedDelta = parseInt(xcapBtn.dataset.xcapDelta, 10);
        shakeEl(xcapModule.querySelector('.kp-xcap-chips'), 'kp-xcap-chips--shake');
        changePendingExtraQty(lockedSize, lockedDelta);
        spotlightSecondCapSize();
        return;
      }
      var xcapChipEl = xcapBtn.closest('.kp-xcap-chip');
      var xcapSize = xcapChipEl ? xcapChipEl.dataset.xcapSize : null;
      var delta = parseInt(xcapBtn.dataset.xcapDelta, 10);
      // Always stages — see changePendingExtraQty. This must never be
      // gated on cartMutating: it's a synchronous local update (no network),
      // so gating it silently dropped every tap that landed while the
      // previous one's /cart round-trip was still in flight — a rapid
      // tapper saw maybe 1 in 5 taps register. commitPendingExtras still
      // self-guards against overlapping requests (see its own cartMutating
      // check); any taps that stack up during that window get flushed by
      // the trailing re-commit at the end of commitPendingExtras below.
      var isDrawerTap = !!(xcapModule && xcapModule.dataset.xcapContext === 'drawer');
      // Only skip the local render if commitPendingExtras is actually about
      // to run (and render) right behind it — if a commit is already in
      // flight (cartMutating), commitPendingExtras below will no-op (see
      // its own cartMutating guard), so a RAPID second/third tap during
      // that window still needs this render for instant feedback, or it'd
      // look like the tap did nothing until the in-flight request resolves
      // (queued and flushed later by flushPendingCartWork) — that dead
      // window was a real part of what read as "laggy."
      var willCommitNow = isDrawerTap && !cartMutating;
      changePendingExtraQty(xcapSize, delta, willCommitNow);
      // On the PDP the "Add/Update Cart" button is the only thing that
      // writes to /cart. In the drawer, the cart list is right there above
      // the tap, so there's nothing ambiguous about committing immediately
      // — no separate CTA.
      if (isDrawerTap) commitPendingExtras('drawer');
      return;
    }

    if (e.target && e.target.id === 'kp-xcap-set-cta') {
      if (setInCart) commitPendingExtras('pdp');
      else submitMainForm();
      return;
    }

    if (e.target && e.target.classList.contains('kp-size-link')) {
      e.preventDefault();
      var fitBtn  = document.querySelector('#kp-acc-fit .kp-acc-head');
      var fitBody = document.querySelector('#kp-acc-fit .kp-acc-body');
      if (fitBtn && fitBody) {
        fitBtn.setAttribute('aria-expanded', 'true');
        fitBody.hidden = false;
        fitBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    var pgSgBtn   = e.target.closest('.kp-pg-sg-btn');
    var pgSgClose = e.target.closest('.kp-pg-sg-close');
    if (pgSgClose) {
      var popup = pgSgClose.closest('.kp-pg-sg-popup');
      if (popup) popup.classList.remove('is-open');
      return;
    }
    if (pgSgBtn) {
      var wrap  = pgSgBtn.closest('.kp-pg-sg-wrap');
      var popup = wrap && wrap.querySelector('.kp-pg-sg-popup');
      if (popup) {
        var isOpen = popup.classList.contains('is-open');
        document.querySelectorAll('.kp-pg-sg-popup.is-open, .kp-cu-sizeguide-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
        if (!isOpen) {
          if (pgSgBtn.closest('.kp-cart-drawer')) {
            popup.classList.add('is-open');
          } else {
            positionPopup(pgSgBtn, popup);
          }
        }
      }
      return;
    }
    if (!e.target.closest('.kp-pg-sg-wrap')) {
      document.querySelectorAll('.kp-pg-sg-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }

    if (!e.target.closest('.kp-cu-sizeguide-wrap')) {
      document.querySelectorAll('.kp-cu-sizeguide-popup.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }
  });

  function renderCartItems(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return '<p class="kp-cart-empty">Your cart is empty.</p>';
    }

    var colourOrder = [];
    var byColour = {};
    cart.items.forEach(function (item) {
      var raw    = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var colour = raw.split(' / ')[0] || '';
      if (!byColour[colour]) { byColour[colour] = []; colourOrder.push(colour); }
      byColour[colour].push(item);
    });

    var typeRank = { 'The Kindred Set': 0, 'Extra Cap — Kids Sizes': 1, 'Extra Cap — Adult Size': 2 };
    var isExtraCapTitle = { 'Extra Cap — Kids Sizes': true, 'Extra Cap — Adult Size': true };

    // "Toddler (2–4 yrs)" -> "Toddler Cap (2–4 yrs)" — used for the kids
    // add-on line items' combined one-line name+size (see renderItem).
    function capLineName(sizeLabel) {
      var m = sizeLabel.match(/^(\S+)\s*(\(.*\))$/);
      return m ? (m[1] + ' Cap ' + m[2]) : (sizeLabel + ' Cap');
    }

    function renderItem(item) {
      var raw    = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var parts  = raw.split(' / ');
      var colour = parts[0] || '';
      var displayName, size;
      var isAddon = !!isExtraCapTitle[item.product_title];

      if (item.product_title === 'The Kindred Set') {
        displayName = 'The Kindred Set';
        size = parts[1] ? 'Adult & ' + parts[1] : '';
      } else if (item.product_title === 'Extra Cap — Adult Size') {
        // Add-on lines are named + sized in one line now ("Adult Cap
        // (12+ yrs)") instead of a separate name + colour + size stack —
        // was 3 lines tall per add-on, a real height cost with 3-4 items
        // in the cart. Deliberately drops "Extra" from the name: on an
        // already-in-the-cart line item it reads clean either way, and
        // "Extra Youth Cap" specifically risked implying the original Set
        // already included a youth cap (it may have shipped with a
        // toddler or adult second cap instead) — "Youth Cap (5–11 yrs)"
        // just states what this line actually is, no ambiguity. Colour
        // dropped too (Navy-only at launch; revisit if a second
        // colourway ships and these lines need to disambiguate again).
        displayName = 'Adult Cap (12+ yrs)';
        size = '';
      } else {
        displayName = parts[1] ? capLineName(parts[1]) : 'Extra Cap';
        size = '';
      }

      // The add-on module's chip overlays pendingExtras on top of the real
      // cart quantity for instant feedback (see renderAddonModule), so it
      // can race ahead of this line during a rapid multi-tap burst — the
      // chip shows 5 while this line, still waiting on the network
      // confirm for tap #1, shows 1, then jumps straight to 5 once the
      // queued commits resolve. That jump-after-a-freeze is what reads as
      // "laggy" (confirmed on video: chip at 3, this line still at 1).
      // Overlaying the same pendingExtras delta here keeps both numbers
      // moving in lockstep on every tap, matching exactly how the chip
      // already computes its own optimistic qty.
      var addonSizeKey = item.product_title === 'Extra Cap — Adult Size' ? 'Adult (12+ yrs)' : (isAddon ? parts[1] : null);
      var displayQty = (isAddon && addonSizeKey && pendingExtras[addonSizeKey])
        ? Math.max(0, item.quantity + pendingExtras[addonSizeKey])
        : item.quantity;
      var isSet = item.product_title === 'The Kindred Set';
      // colourImg (the PDP gallery's colour-matched thumbnail) is only a
      // safe fallback for the Set line — its gallery genuinely shows the
      // caps. For an add-on line it's wrong: getColourImage just returns
      // the FIRST "navy" thumbnail in the gallery, which is the lifestyle
      // hero shot (dad + child), not a plain cap product photo. That
      // showed up as a real, reproducible bug — tapping an add-on chip
      // briefly flashes the lifestyle photo on the new line (the
      // optimistic item built in buildOptimisticCart has image:null before
      // the real /cart response arrives with the correct product image).
      // The bare placeholder div below is a more honest brief loading
      // state than a wrong photo.
      var colourImg = (!isAddon && colour) ? getColourImage(colour) : null;
      // item.image is the real Shopify cart line image (variant image = front-on caps);
      // it must win over the PDP gallery's colour-matched thumbnail.
      var imgSrc = item.image || colourImg;
      var img = imgSrc
        ? '<img class="kp-cart-img" src="' + imgSrc + '" alt="" width="72" height="72" loading="eager">'
        : '<div class="kp-cart-img kp-cart-img--ph"></div>';

      var priceHtml = '$' + (item.final_line_price / 100).toFixed(0);

      return '<div class="kp-cart-item' + (isAddon ? ' kp-cart-item--addon' : '') + '">'
        + img
        + '<div class="kp-cart-item-info">'
        +   '<div class="kp-cart-item-top">'
        +     '<p class="kp-cart-item-name">' + displayName + '</p>'
        +     '<p class="kp-cart-item-price">' + priceHtml + '</p>'
        +   '</div>'
        +   (size ? '<p class="kp-cart-item-variant">' + size + '</p>' : '')
        +   '<div class="kp-cart-item-bot">'
        +     '<div class="kp-cart-qty">'
        +       '<button class="kp-qty-btn" data-key="' + item.key + '" data-delta="-1" data-set="' + isSet + '" type="button">&#x2212;</button>'
        +       '<span class="kp-qty-val">' + displayQty + '</span>'
        +       '<button class="kp-qty-btn" data-key="' + item.key + '" data-delta="1" type="button">+</button>'
        +     '</div>'
        +     '<button class="kp-cart-remove" data-key="' + item.key + '" data-set="' + isSet + '" type="button" aria-label="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M216 50H40a6 6 0 0 0 0 12h10v146a14 14 0 0 0 14 14h128a14 14 0 0 0 14-14V62h10a6 6 0 0 0 0-12m-22 158a2 2 0 0 1-2 2H64a2 2 0 0 1-2-2V62h132ZM82 24a6 6 0 0 1 6-6h80a6 6 0 0 1 0 12H88a6 6 0 0 1-6-6"/></svg></button>'
        +   '</div>'
        + '</div>'
        + '</div>';
    }

    return colourOrder.map(function (colour, groupIdx) {
      var sorted = byColour[colour].slice().sort(function (a, b) {
        var ra = typeRank[a.product_title] != null ? typeRank[a.product_title] : 99;
        var rb = typeRank[b.product_title] != null ? typeRank[b.product_title] : 99;
        return ra - rb;
      });
      var divider = groupIdx > 0 ? '<hr class="kp-cart-divider">' : '';
      return divider + sorted.map(renderItem).join('');
    }).join('');
  }

  // Single Extra Cap add-on module — chips + inline qty steppers. Renders
  // identically in the cart drawer and on the PDP (renderAddonModule is
  // called from both mount points every time the cart changes), driven
  // directly off real cart quantities rather than a staged pre-cart state.
  var SIZE_ORDER = ['Toddler (2–4 yrs)', 'Youth (5–11 yrs)', 'Adult (12+ yrs)'];

  function renderAddonModule(cart, opts) {
    opts = opts || {};
    var locked = !!opts.locked;
    // Qty shown is always the live cart baseline plus whatever's staged —
    // baseline is 0 pre-Set-in-cart, so this collapses to the old "purely
    // staged" behaviour in that case with no special-casing needed.
    var chipsHtml = SIZE_ORDER.map(function (size) {
      var v = findExtraCapVariant(size);
      if (!v) return '';
      var qty = Math.max(0, extraBaselineQty(cart, size) + (pendingExtras[size] || 0));
      var soldOut = v.available === false;
      var shortName = size.split(' (')[0];
      var ageLabel = '(' + size.split(' (')[1];
      return '<div class="kp-xcap-chip kp-xcap-chip-f' + (soldOut ? ' is-soldout' : '') + (qty > 0 ? ' has-qty' : '') + '" data-xcap-size="' + size + '">'
        + '<div class="kp-chip-f-name">'
        +   '<span class="kp-chip-f-size">' + shortName + '</span>'
        +   '<span class="kp-chip-f-age">' + ageLabel + '</span>'
        + '</div>'
        + (soldOut
          ? '<div class="kp-xcap-soldout-label">Sold out</div>'
          : '<div class="kp-xcap-stepper-f">'
            +   '<button class="kp-xcap-btn kp-xcap-minus" data-xcap-variant="' + v.id + '" data-xcap-delta="-1" type="button" aria-label="Remove one ' + size + ' extra cap"' + (qty === 0 ? ' disabled' : '') + '>&#x2212;</button>'
            +   '<span class="kp-xcap-qty">' + qty + '</span>'
            +   '<button class="kp-xcap-btn kp-xcap-plus" data-xcap-variant="' + v.id + '" data-xcap-delta="1" type="button" aria-label="Add one ' + size + ' extra cap">+</button>'
            + '</div>')
        + '</div>';
    }).join('');

    // Shown whenever there's a staged change against the real cart, PDP
    // only — the drawer commits on every tap (see the click handler), so
    // there's nothing for a CTA to confirm there.
    var setCtaHtml = (opts.showSetCta && opts.context !== 'drawer')
      ? '<button class="kp-xcap-set-cta" id="kp-xcap-set-cta" type="button">' + opts.ctaLabel + '</button>'
      : '';

    // Tick/shine plays in both mounts now. "Unlocked" counts a staged-but-
    // not-yet-committed extra too (not just cartHasExtraCap), so the PDP
    // badge reacts the instant a chip is tapped instead of waiting on a
    // network round-trip that mostly just gets covered by the drawer
    // opening straight after anyway.
    var badgeBaked = cartHasExtraCap(cart) || pendingExtrasTotal() > 0;
    // Interactive in both mounts: the badge is a real button, greyed out
    // while locked, that spotlights the chips below it on tap — same
    // mechanism as spotlightSecondCapSize, retargeted (see
    // spotlightXcapChips, which branches on data-xcap-context to target
    // the right chips/overlay for whichever mount was tapped).
    var badgeTag = 'button';
    var badgeHtml = '<' + badgeTag + ' class="kp-xcap-badge' + (badgeBaked ? ' is-unlocked' : '') + ' kp-xcap-badge--interactive" type="button">'
      + '<span class="kp-xcap-badge-shine" aria-hidden="true"></span>'
      + 'Free shipping'
      + '<span class="kp-xcap-badge-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span>'
      + '</' + badgeTag + '>';

    return '<div class="kp-xcap' + (locked ? ' is-locked' : '') + '" data-xcap-locked="' + locked + '" data-xcap-context="' + (opts.context || 'pdp') + '">'
      + '<div class="kp-xcap-head">'
      +   '<div class="kp-xcap-head-top">'
      +     '<p class="kp-xcap-title">Build your Kindred family.</p>'
      +     badgeHtml
      +   '</div>'
      +   '<ul class="kp-xcap-bullets">'
      +     '<li><span class="kp-xcap-bullet-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span>Add any extra cap for $' + PRICES.extraCap + '.</span></li>'
      +     '<li><span class="kp-xcap-bullet-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span>Free shipping when you add any extra cap.</span></li>'
      +     '<li><span class="kp-xcap-bullet-tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg></span><span>Perfect for the other parent or siblings.</span></li>'
      +   '</ul>'
      + '</div>'
      + '<div class="kp-xcap-chips">' + chipsHtml + '</div>'
      + setCtaHtml
      + '</div>';
  }

  var lastFreeShipState = null;
  var badgeWasUnlocked = null;

  // Flips every .kp-xcap-badge's unlocked state to match the real cart (or
  // a staged-but-uncommitted extra), animating only on a genuine
  // locked<->unlocked edge — both mounts, PDP and drawer. Call once per
  // renderCart, after both mounts have fresh markup in the DOM.
  function syncFreeShipBadges(cart) {
    var unlocked = cartHasExtraCap(cart) || pendingExtrasTotal() > 0;
    var badges = document.querySelectorAll('.kp-xcap-badge');
    // The moment it's genuinely unlocked, clear any active spotlight — the
    // whole point was getting here, so it has nothing left to point at.
    if (unlocked) dismissXcapSpotlight();
    if (badgeWasUnlocked === null) {
      badges.forEach(function (b) { b.classList.toggle('is-unlocked', unlocked); });
      badgeWasUnlocked = unlocked;
      return;
    }
    if (unlocked === badgeWasUnlocked) return;
    // Force the freshly-inserted "old state" markup to commit to a frame
    // before flipping, otherwise the class change and its transition can
    // collapse into the same paint and never actually animate.
    badges.forEach(function (b) { void b.offsetWidth; });
    badges.forEach(function (b) { b.classList.toggle('is-unlocked', unlocked); });
    badgeWasUnlocked = unlocked;
  }

  // Locked until the customer has committed to a second-cap size — "more
  // than two" isn't meaningful before there's a "two" to add to, and this
  // is what keeps someone from accidentally buying a lone Extra Cap with
  // no Set in the cart at all.
  function isAddonModuleLocked() {
    return !setInCart && !selectedSize;
  }

  function pdpAddonOpts(cart) {
    return {
      showSetCta: xcapShowCta(),
      ctaLabel: xcapCtaLabel(),
      context: 'pdp',
      locked: isAddonModuleLocked()
    };
  }

  function renderPdpAddonMount(cart) {
    var pdpMount = document.getElementById('kp-addon-module-mount');
    if (!pdpMount) return;
    pdpMount.innerHTML = renderAddonModule(cart, pdpAddonOpts(cart));
  }

  // CSS used a flat min-height:195px on #kp-cart-body (room for 2 real
  // items) so the item list never gets squeezed by the add-on module below
  // it — Daniel's rule, "first 2 items always fully visible." But a FLAT
  // floor reserves that same 195px even with only 1 item in the cart,
  // which is dead space, not a safety margin — and on a short/unmaximized
  // browser window that dead space was exactly what pushed the trust
  // badges and Checkout below the fold entirely (confirmed on video: a
  // 1-item cart on a 13" MacBook left a visible empty gap above the
  // module, with Checkout cut off below the visible screen). Fixed by
  // measuring the REAL rendered height of min(itemCount, 2) items after
  // every render and setting min-height to exactly that — enough for the
  // 2-item rule when there are 2+, none of the dead space when there's
  // only 1, and this naturally self-corrects if item row heights ever
  // change (font-size tweak, a 3rd line added, etc.) since it's measured
  // live rather than a hand-typed px guess.
  function syncCartBodyMinHeight() {
    var bodyEl = document.getElementById('kp-cart-body');
    if (!bodyEl) return;
    var items = bodyEl.querySelectorAll('.kp-cart-item');
    if (!items.length) { bodyEl.style.minHeight = ''; return; }
    var wanted = Math.min(items.length, 2);
    var total = 0;
    for (var i = 0; i < wanted; i++) total += items[i].getBoundingClientRect().height;
    bodyEl.style.minHeight = Math.ceil(total) + 'px';
  }

  function renderCart(cart) {
    lastCart = cart;
    var bodyEl      = document.getElementById('kp-cart-body');
    var addonMount  = document.getElementById('kp-cart-addon-mount');
    var subtotalEl  = document.getElementById('kp-cart-subtotal');
    var cartIsEmpty = !cart || !cart.items || !cart.items.length;
    // Items list and add-on module render into separate containers now —
    // only the item list scrolls (kp-cart-body); the module stays fully
    // visible below it instead of getting pushed down/clipped as the item
    // list grows. The drawer's own module only makes sense once there's
    // something in the cart to add more to.
    if (bodyEl) bodyEl.innerHTML = renderCartItems(cart);
    syncCartBodyMinHeight();
    if (addonMount) addonMount.innerHTML = cartIsEmpty ? '' : renderAddonModule(cart, {
      locked: isAddonModuleLocked(),
      showSetCta: xcapShowCta(),
      ctaLabel: xcapCtaLabel(),
      context: 'drawer'
    });
    if (subtotalEl && cart) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(0);

    renderPdpAddonMount(cart);
    syncFreeShipBadges(cart);

    var shipEl = document.getElementById('kp-cart-ship-line');
    var shipFillEl = document.getElementById('kp-cart-ship-fill');
    var shipWrapEl = document.getElementById('kp-cart-ship');
    var subtotalLabelEl = document.getElementById('kp-cart-subtotal-label');
    if (shipEl && cart) {
      var hasExtra = cartHasExtraCap(cart);
      lastFreeShipState = hasExtra;
      // Not-yet-unlocked state intentionally shows nothing here for now —
      // a proper design for this moment is still being worked out. No
      // animation on this line either, for the same reason.
      if (shipWrapEl) shipWrapEl.hidden = !hasExtra;
      if (hasExtra) {
        shipEl.innerHTML = '<span class="kp-ship-tick">'
          + '<svg width="13" height="13" viewBox="0 0 13 13"><path d="M2.5 6.5l3 3 5-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '</span> Free shipping!';
        shipEl.classList.add('kp-cart-ship-line--unlocked');
      }
      // "Subtotal" implies something more gets added before checkout —
      // once shipping is free, this number IS the total, so say that.
      if (subtotalLabelEl) subtotalLabelEl.textContent = hasExtra ? 'Total' : 'Subtotal';
      if (shipFillEl) {
        shipFillEl.style.width = hasExtra ? '100%' : '0%';
        shipFillEl.classList.toggle('kp-cart-ship-fill--unlocked', hasExtra);
      }
    }

    var drawerEl = document.getElementById('kp-cart-drawer');
    if (drawerEl) {
      var isEmpty = !cart || !cart.items || !cart.items.length;
      drawerEl.classList.toggle('is-empty', isEmpty);
    }
  }

  function updateBagCount(cart) {
    var el = document.getElementById('kp-bag-count');
    var btn = document.getElementById('kp-bag-btn');
    if (!el) return;
    var n = (cart && cart.item_count) ? cart.item_count : 0;
    el.textContent = n;
    el.hidden = n === 0;
    if (btn) btn.classList.toggle('kp-bag-btn--has-items', n > 0);
  }

  function openCartDrawer(cart) {
    renderCart(cart);
    updateBagCount(cart);
    if (typeof gtag === 'function') gtag('event', 'addon_module_view', { event_category: 'ecommerce', surface: 'cart_drawer' });
    // Force a genuinely fresh copy of the express checkout buttons every
    // time the drawer opens, rather than trusting whatever DOM/iframe state
    // is already sitting there — see the comment on expressPristineHTML.
    if (expressEl && expressPristineHTML != null) {
      expressEl.innerHTML = expressPristineHTML;
    }
    var overlay = document.getElementById('kp-cart-overlay');
    var drawer  = document.getElementById('kp-cart-drawer');
    if (overlay) overlay.classList.add('is-open');
    if (drawer)  drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Belt-and-suspenders: also nudge the SDK to re-measure once the drawer
    // has actually finished animating into view on screen.
    if (drawer) {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 400);
    }
  }

  function closeCartDrawer() {
    var overlay = document.getElementById('kp-cart-overlay');
    var drawer  = document.getElementById('kp-cart-drawer');
    if (overlay) overlay.classList.remove('is-open');
    if (drawer)  drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  var cartCloseBtn  = document.getElementById('kp-cart-close');
  var cartOverlayEl = document.getElementById('kp-cart-overlay');
  if (cartCloseBtn)  cartCloseBtn.addEventListener('click', closeCartDrawer);
  if (cartOverlayEl) cartOverlayEl.addEventListener('click', closeCartDrawer);

  var bagBtn = document.getElementById('kp-bag-btn');
  if (bagBtn) {
    bagBtn.addEventListener('click', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { openCartDrawer(cart); })
        .catch(function () {});
    });
  }

  var cartBodyEl = document.getElementById('kp-cart-body');
  if (cartBodyEl) {
    cartBodyEl.addEventListener('click', function (e) {
      var t = e.target;
      var qtyBtn = null, removeBtn = null;
      while (t && t !== cartBodyEl) {
        if (t.classList && t.classList.contains('kp-qty-btn'))     { qtyBtn = t; break; }
        if (t.classList && t.classList.contains('kp-cart-remove')) { removeBtn = t; break; }
        t = t.parentElement;
      }

      if (qtyBtn) {
        var key    = qtyBtn.dataset.key;
        var delta  = parseInt(qtyBtn.dataset.delta, 10);
        var isSet  = qtyBtn.dataset.set === 'true';
        var valEl  = qtyBtn.parentElement.querySelector('.kp-qty-val');
        var newQty = Math.max(0, parseInt(valEl ? valEl.textContent : '1', 10) + delta);
        if (newQty === 0 && isSet) {
          removeSetItem(key);
        } else {
          // Optimistic update always applies instantly, never gated on
          // cartMutating — see queueQtyCommit for why (a rapid tapper used
          // to see maybe 1 in 5 taps register at all).
          var optQty = optimisticCartChange(key, newQty);
          if (optQty) { lastCart = optQty; applyCartState(optQty); renderCart(optQty); }
          queueQtyCommit(key, newQty);
        }
      }
      if (removeBtn) {
        var key   = removeBtn.dataset.key;
        var isSet = removeBtn.dataset.set === 'true';
        if (isSet) {
          removeSetItem(key);
        } else {
          var optRem = optimisticCartChange(key, 0);
          if (optRem) { lastCart = optRem; applyCartState(optRem); renderCart(optRem); }
          queueQtyCommit(key, 0);
        }
      }
    });
  }

  function enforceColourConstraint(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var setColours = [];
    cart.items.forEach(function (i) {
      if (i.product_title === 'The Kindred Set') {
        var c = i.variant_title ? i.variant_title.split(' / ')[0] : null;
        if (c && setColours.indexOf(c) === -1) setColours.push(c);
      }
    });
    var toRemove = [];
    cart.items.forEach(function (i) {
      if (i.product_title === 'Extra Cap — Kids Sizes' || i.product_title === 'Extra Cap — Adult Size') {
        var c = i.variant_title ? i.variant_title.split(' / ')[0] : null;
        if (c && setColours.indexOf(c) === -1) toRemove.push(i.key);
      }
    });
    if (!toRemove.length) return Promise.resolve(cart);
    return toRemove.reduce(function (p, key) {
      return p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function (r) { return r.json(); });
      });
    }, Promise.resolve())
    .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); });
  }

  function removeSetItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.items) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
          applyCartState(real); renderCart(real);
          showDrawerError('Could not update cart — please try again.');
        });
        return;
      }
      var setsRemain = cart.items && cart.items.some(function (item) {
        return item.product_title === 'The Kindred Set';
      });
      if (!setsRemain) {
        clearCart();
      } else {
        enforceColourConstraint(cart).then(function (cleaned) {
          applyCartState(cleaned);
          renderCart(cleaned);
        });
      }
    }).catch(function () {});
  }

  function clearCart() {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyCartState(cart);
        renderCart(cart);
      })
      .catch(function () {});
  }

  function mergeCartAdd(addedData) {
    if (!lastCart || !addedData || !addedData.items || !addedData.items.length) return null;
    var cart = JSON.parse(JSON.stringify(lastCart));
    addedData.items.forEach(function (newItem) {
      var found = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === newItem.variant_id) {
          cart.items[i].quantity += newItem.quantity;
          cart.items[i].line_price = cart.items[i].price * cart.items[i].quantity;
          cart.items[i].final_line_price = cart.items[i].price * cart.items[i].quantity;
          found = true;
          break;
        }
      }
      if (!found) cart.items.push(JSON.parse(JSON.stringify(newItem)));
      cart.item_count = (cart.item_count || 0) + newItem.quantity;
      cart.total_price = (cart.total_price || 0) + newItem.price * newItem.quantity;
    });
    lastCart = cart;
    return cart;
  }

  function optimisticCartChange(key, newQty) {
    if (!lastCart) return null;
    var cart = JSON.parse(JSON.stringify(lastCart));
    var idx = -1;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) { idx = i; break; }
    }
    if (idx === -1) return null;
    var item = cart.items[idx];
    var oldQty = item.quantity;
    if (newQty <= 0) {
      cart.items.splice(idx, 1);
      cart.item_count -= oldQty;
      cart.total_price -= item.price * oldQty;
    } else {
      var diff = newQty - oldQty;
      item.quantity = newQty;
      item.line_price = item.price * newQty;
      item.final_line_price = item.price * newQty;
      cart.item_count += diff;
      cart.total_price += item.price * diff;
    }
    return cart;
  }

  function reconcileInBackground(optimistic) {
    // Always re-render against the server's real cart, even when the
    // optimistic guess's totals happen to match exactly (the common case
    // for a plain add). Any optimistic line was rendered with a fake key
    // (e.g. 'optimistic-<variantId>') that Shopify has never heard of —
    // skipping this render on a "no difference" totals check left that
    // fake key sitting in the live DOM, so a later qty tap on that line
    // sent the fake key to /cart/change.js and got a real error back.
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (real) {
      if (!real || !real.items) return;
      lastCart = real;
      applyCartState(real);
      renderCart(real);
    });
  }

  function showDrawerError(msg) {
    var body = document.getElementById('kp-cart-body');
    if (!body) return;
    var p = document.createElement('p');
    p.className = 'kp-cart-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    body.insertBefore(p, body.firstChild);
    setTimeout(function () { if (p.parentElement) p.remove(); }, 5000);
  }

  function applyCartState(cart) {
    var wasInCart = setInCart;
    setInCart = !!(cart && cart.items && cart.items.some(function (item) {
      return item.product_title === 'The Kindred Set';
    }));
    updateBagCount(cart);
    if (setInCart && !wasInCart) {
      resetAddonSelections();
      injectStandaloneButtons();
      // Pre-select whichever second-cap-size chip matches the Set already
      // in the cart — covers landing on the PDP after adding the Set from
      // the homepage's own inline selector, which previously left every
      // chip unselected even though a real choice had already been made
      // and committed.
      var setLine = cart.items.find(function (item) { return item.product_title === 'The Kindred Set'; });
      var cartSize = setLine && setLine.variant_title ? setLine.variant_title.split(' / ')[1] : null;
      if (cartSize) {
        selectedSize = cartSize;
        document.querySelectorAll('.kp-chip:not([data-addon-type])').forEach(function (b) {
          var match = b.dataset.size === cartSize;
          b.classList.toggle('is-active', match);
          b.setAttribute('aria-pressed', String(match));
        });
      }
    } else if (!setInCart && wasInCart) {
      removeStandaloneButtons();
      selectedSize = null;
      document.querySelectorAll('.kp-chip:not([data-addon-type])').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
    }
    updateCTA();
  }

  function resetAddonSelections() {
    ['kids', 'adult', 'set2'].forEach(function (key) {
      addonState[key].open = false;
      addonState[key].confirmed = false;
      if ('size' in addonState[key]) addonState[key].size = null;
      var box = document.getElementById('kp-addon-box-' + key);
      if (box) box.classList.remove('is-open', 'is-active');
      var trigger = document.querySelector('[data-addon="' + key + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.querySelectorAll('[data-addon-type="' + key + '"]').forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
      });
    });
    addonState.set2.colour = null;
    document.querySelectorAll('.kp-set2-sw').forEach(function (btn) {
      var match = btn.dataset.colour === selectedColour;
      btn.classList.toggle('is-active', match);
      btn.setAttribute('aria-pressed', String(match));
    });
    setSet2ColourVal(selectedColour);
  }

  function kidsAddonBtnLabel() {
    if (!addonState.kids.size) return 'Add Another Cap';
    var price = (addonState.kids.size === 'Adult (12+ yrs)') ? PRICES.adult : PRICES.kids;
    return 'Add Another Kids Cap — $' + price;
  }

  function updateStandaloneBtn(type) {
    var btn = document.getElementById('kp-standalone-' + type);
    if (!btn) return;
    var locked;
    if (type === 'adult') {
      locked = !addonState.adult.confirmed;
    } else {
      locked = !addonState[type].confirmed || !addonState[type].size;
    }
    btn.classList.toggle('is-locked', locked);
    btn.disabled = (type === 'adult') ? locked : false;
    if (type === 'kids') btn.textContent = kidsAddonBtnLabel();
  }

  function addStandaloneToCart(variantId, btnEl, originalText) {
    if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Adding…'; }
    if (btnEl && btnEl.parentElement) {
      var oldErr = btnEl.parentElement.querySelector('.kp-standalone-error');
      if (oldErr) oldErr.remove();
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || data.message || 'Could not add to cart.');
        }, function () {
          throw new Error('Could not add to cart.');
        });
      }
      return res.json().then(function (addedData) {
        var optimistic = mergeCartAdd(addedData);
        if (optimistic) { reconcileInBackground(optimistic); return optimistic; }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      });
    })
    .then(function (cart) {
      applyCartState(cart);
      if (setInCart) {
        resetAddonSelections();
        removeStandaloneButtons();
        injectStandaloneButtons();
      }
      openCartDrawer(cart);
    })
    .catch(function (err) {
      if (btnEl) {
        btnEl.disabled = false;
        btnEl.textContent = originalText;
        if (btnEl.parentElement) {
          var msg = document.createElement('p');
          msg.className = 'kp-cart-error kp-standalone-error';
          msg.setAttribute('role', 'alert');
          msg.textContent = (err && err.message) ? err.message : 'Could not add to cart — please try again.';
          btnEl.parentElement.appendChild(msg);
          setTimeout(function () { if (msg.parentElement) msg.remove(); }, 6000);
        }
      }
    });
  }

  function injectStandaloneButtons() {
    var kidsInner = document.querySelector('#kp-addon-expander-kids .kp-addon-expander-inner');
    if (kidsInner && !document.getElementById('kp-standalone-kids')) {
      var kBtn = document.createElement('button');
      kBtn.id = 'kp-standalone-kids';
      kBtn.className = 'kp-addon-standalone-btn';
      kBtn.type = 'button';
      kBtn.textContent = kidsAddonBtnLabel();
      kBtn.classList.add('is-locked');
      kBtn.addEventListener('click', function () {
        if (!addonState.kids.size) {
          var chipsEl = document.querySelector('#kp-addon-expander-kids .kp-chips');
          if (chipsEl) {
            chipsEl.classList.remove('kp-chips--shake');
            void chipsEl.offsetWidth;
            chipsEl.classList.add('kp-chips--shake');
            chipsEl.addEventListener('animationend', function () { chipsEl.classList.remove('kp-chips--shake'); }, { once: true });
          }
          return;
        }
        var kv = resolveKidsAddonVariant(selectedColour, addonState.kids.size);
        if (!kv) return;
        addStandaloneToCart(kv.id, kBtn, kidsAddonBtnLabel());
      });
      kidsInner.appendChild(kBtn);
    }

    var adultInner = document.querySelector('#kp-addon-expander-adult .kp-addon-expander-inner');
    if (adultInner && !document.getElementById('kp-standalone-adult')) {
      var aBtn = document.createElement('button');
      aBtn.id = 'kp-standalone-adult';
      aBtn.className = 'kp-addon-standalone-btn';
      aBtn.type = 'button';
      aBtn.textContent = 'Add Another Adult Cap — $' + PRICES.adult;
      aBtn.disabled = true;
      aBtn.addEventListener('click', function () {
        var av = findAdultCapVariant(selectedColour);
        if (!av) return;
        addStandaloneToCart(av.id, aBtn, 'Add Another Adult Cap — $' + PRICES.adult);
      });
      adultInner.appendChild(aBtn);
    }

    var set2Inner = document.querySelector('#kp-addon-expander-set2 .kp-addon-expander-inner');
    if (set2Inner && !document.getElementById('kp-standalone-set2')) {
      var sBtn = document.createElement('button');
      sBtn.id = 'kp-standalone-set2';
      sBtn.className = 'kp-addon-standalone-btn';
      sBtn.type = 'button';
      sBtn.textContent = 'Add Another Set — $' + PRICES.set;
      sBtn.classList.add('is-locked');
      sBtn.addEventListener('click', function () {
        if (!addonState.set2.size) {
          var chipsEl = document.querySelector('#kp-addon-expander-set2 .kp-chips');
          if (chipsEl) {
            chipsEl.classList.remove('kp-chips--shake');
            void chipsEl.offsetWidth;
            chipsEl.classList.add('kp-chips--shake');
            chipsEl.addEventListener('animationend', function () { chipsEl.classList.remove('kp-chips--shake'); }, { once: true });
          }
          return;
        }
        var set2Colour = addonState.set2.colour || selectedColour;
        var sv = findSetVariant(set2Colour, addonState.set2.size);
        if (!sv) return;
        addStandaloneToCart(sv.id, sBtn, 'Add Another Set — $' + PRICES.set);
      });
      set2Inner.appendChild(sBtn);
    }
  }

  function removeStandaloneButtons() {
    ['kids', 'adult', 'set2'].forEach(function (key) {
      var btn = document.getElementById('kp-standalone-' + key);
      if (btn && btn.parentElement) btn.parentElement.removeChild(btn);
    });
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      lastCart = cart;
      applyCartState(cart);
      // Populate the PDP's own add-on module immediately on load — it must
      // be visible under the Add to Cart button without requiring the
      // drawer to have been opened first.
      renderPdpAddonMount(cart);
      if (typeof gtag === 'function') gtag('event', 'addon_module_view', { event_category: 'ecommerce', surface: 'product_page' });
    })
    .catch(function () {});

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (setInCart) {
      if (lastCart) {
        openCartDrawer(lastCart);
      } else {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(openCartDrawer).catch(function () {});
      }
      return;
    }

    if (!variantInput.value) {
      spotlightSecondCapSize();
      return;
    }

    // The Set plus every staged extra cap go in as one batched request —
    // this is the actual commit moment for anything chosen in the
    // "Make it more than two" module while the Set wasn't in cart yet.
    var items = [{ id: parseInt(variantInput.value, 10), quantity: 1 }];
    var addedExtraCount = 0;
    SIZE_ORDER.forEach(function (size) {
      var qty = pendingExtras[size] || 0;
      if (qty <= 0) return;
      var v = findExtraCapVariant(size);
      if (!v) return;
      items.push({ id: v.id, quantity: qty });
      addedExtraCount += qty;
    });

    atcBtn.disabled = true;
    atcBtn.classList.add('is-loading');
    atcBtn.innerHTML = '<span class="kp-atc-spinner" aria-hidden="true"></span>Adding…';
    syncStickyCta();
    var atcErrEl = document.getElementById('kp-atc-error');
    if (atcErrEl) atcErrEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw new Error(data.description || 'Could not add to cart.');
        }).catch(function (err) {
          throw err.message ? err : new Error('Could not add to cart.');
        });
      }
      return res.json();
    })
    .then(function (addedData) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('is-loading');
      var orderValue = PRICES.set + addedExtraCount * PRICES.extraCap;
      if (typeof gtag === 'function') gtag('event', 'add_to_cart', { event_category: 'ecommerce', value: orderValue, currency: 'AUD' });
      resetPendingExtras();
      // Open the drawer off an instant local merge of the add.js response
      // instead of waiting on a second full /cart.js round-trip — that
      // second trip used to sit on the critical path before the customer
      // saw anything happen at all. reconcileInBackground quietly corrects
      // this against the server a moment later (same pattern already used
      // by the standalone extra-cap add button). Falls back to the slower
      // path only if lastCart hasn't been populated yet — normally lost to
      // the page's own bootstrap /cart.js fetch below, which has a full
      // page-load-to-first-tap window to finish.
      var optimistic = mergeCartAdd(addedData);
      if (optimistic) {
        applyCartState(optimistic);
        openCartDrawer(optimistic);
        reconcileInBackground(optimistic);
        return;
      }
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        applyCartState(cart);
        openCartDrawer(cart);
      });
    })
    .catch(function (err) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('is-loading');
      updateCTA();
      var errEl = document.getElementById('kp-atc-error');
      if (errEl) {
        errEl.textContent = (err && err.message) ? err.message : 'Could not add to cart — please try again.';
        errEl.hidden = false;
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        applyCartState(cart);
        var drawer = document.getElementById('kp-cart-drawer');
        if (drawer && drawer.classList.contains('is-open')) openCartDrawer(cart);
      }).catch(function () {});
    });
  });

  function toggleCtaHelper(show) {
    var helper = document.getElementById('kp-cta-helper');
    if (helper) helper.hidden = !show;
  }

  var stickyBar = document.getElementById('kp-sticky-bar');
  var stickyCta = document.getElementById('kp-sticky-cta');
  var stickyPriceEl = document.querySelector('.kp-sticky-price');

  // 2026-08-09: stickyPriceEl used to be static liquid output
  // ({{ product.price }}) and never updated — always showed $69 no matter
  // how many extra caps were staged in the "Build your Kindred family"
  // module, even though the button right next to it correctly said "Add 4
  // Caps to Cart". Now recomputed every sync: base Set price plus any
  // staged extras before it's in the cart, or the real cart subtotal once
  // it is (matches what tapping the button will actually do at that
  // moment, rather than a number that was only ever right for a lone Set).
  function syncStickyCta() {
    if (!stickyCta) return;
    stickyCta.textContent = atcBtn.textContent.trim();
    stickyCta.setAttribute('aria-disabled', atcBtn.getAttribute('aria-disabled') || 'false');
    stickyCta.classList.toggle('kp-atc--view-cart', atcBtn.classList.contains('kp-atc--view-cart'));
    if (stickyPriceEl) {
      var total = setInCart
        ? (lastCart ? lastCart.total_price / 100 : PRICES.set)
        : PRICES.set + pendingExtrasTotal() * PRICES.extraCap;
      stickyPriceEl.textContent = '$' + Math.round(total);
    }
  }

  function submitMainForm() {
    if (atcBtn.disabled) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function updateAddonCtas() {
    // Express/dynamic checkout only knows about the single Set variant —
    // it would silently drop any staged extras, so hide it whenever the
    // customer has something staged and force them through the real
    // "Add Set to Cart" flow that actually includes those extras.
    var anyAddon = pendingExtrasTotal() > 0;
    var xp = document.getElementById('kp-express-wrap');
    if (xp) xp.hidden = setInCart || !selectedSize || !variantInput.value || anyAddon;

    var teaser = document.querySelector('.kp-free-ship-teaser');
    if (teaser) {
      if (!selectedSize && !setInCart) {
        teaser.hidden = true;
      } else {
        teaser.hidden = false;
        var thresholdCents = PRICES.freeShipThresholdCents;
        var projectedCents = calcTotal() * 100;
        if (setInCart && lastCart) projectedCents = lastCart.total_price;
        if (anyAddon || projectedCents >= thresholdCents) {
          teaser.classList.add('kp-free-ship-teaser--unlocked');
          teaser.classList.remove('kp-free-ship-teaser--pulse');
          teaser.innerHTML = '<span class="kp-teaser-arrow" aria-hidden="true">&#10003;</span> Free shipping!';
        } else {
          var shipRemaining = Math.ceil((thresholdCents - projectedCents) / 100);
          teaser.classList.remove('kp-free-ship-teaser--unlocked');
          teaser.classList.add('kp-free-ship-teaser--pulse');
          teaser.innerHTML = '<span class="kp-teaser-arrow" aria-hidden="true">&rarr;</span> $' + shipRemaining + ' from free shipping. Add any extra cap.';
        }
      }
    }
    var live = document.getElementById('kp-live');
    if (live && live.textContent !== atcBtn.textContent) live.textContent = atcBtn.textContent;
    ['kids', 'adult', 'set2'].forEach(function (type) {
      var btn = document.querySelector('[data-addon-cta="' + type + '"]');
      if (!btn) return;
      var show = !setInCart && addonState[type].confirmed;
      btn.hidden = !show;
      if (show) btn.textContent = 'Add Set to Cart — $' + calcTotal();
      var unlock = document.querySelector('[data-addon-unlock="' + type + '"]');
      if (unlock) unlock.hidden = !show;
    });
  }

  document.querySelectorAll('.kp-addon-cta').forEach(function (btn) {
    btn.addEventListener('click', submitMainForm);
  });

  if (stickyCta) stickyCta.addEventListener('click', submitMainForm);

  var secondCta = document.getElementById('kp-second-cta');
  if (secondCta) secondCta.addEventListener('click', submitMainForm);

  if (stickyBar && 'IntersectionObserver' in window) {
    var kpAtcWrap = document.querySelector('.kp-atc-wrap');
    if (kpAtcWrap) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
      }, { rootMargin: '-64px 0px 0px 0px' }).observe(kpAtcWrap);
    }
  }

  toggleCtaHelper(false);
  syncStickyCta();

  // 2026-08-09: this used to read "Limited first run. Ships mid-August. /
  // Order before Friday 28 August..." — ad data showed a severe ATC→
  // Checkout drop-off (39→2 on the top ad that week) and this note fires
  // right at that step (after Add to Cart, visible on the page and behind
  // the cart drawer overlay once it opens), so the delay framing was cut.
  // Daniel liked the box itself, just not "ships mid-August" — reframed
  // around the same order-by deadline the announcement bar uses instead of
  // removing it outright. Restyled to reuse .kp-atc-trust2/.kp-purchase-trust2
  // (see the liquid) — #kp-delivery-1/2 are now the <strong> text nodes
  // inside that pill's two items, not independently-hidden <p> rows, so
  // only the outer wrap needs the hidden toggle.
  (function () {
    var wrap = document.getElementById('kp-delivery-wrap');
    var el1 = document.getElementById('kp-delivery-1');
    var el2 = document.getElementById('kp-delivery-2');
    if (el1) el1.textContent = 'Order by Friday 28 August';
    if (el2) el2.textContent = 'Arrives before Father’s Day';
    if (wrap) wrap.hidden = false;
  })();

})();

(function () {
  var cards = document.querySelectorAll('.kp-card');
  if (!cards.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var startY = vh, endY = vh * 0.12;
    cards.forEach(function (card, i) {
      if (i === cards.length - 1) return;
      var r = cards[i + 1].getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (startY - r.top) / (startY - endY)));
      var scale = 1 - p * 0.06;
      var rot = p * (i % 2 ? 1.4 : -1.4);
      card.style.transform = 'scale(' + scale + ') rotate(' + rot + 'deg)';
    });
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();

(function () {
  // Craft-intro scroll-SCRUBBED reveal — how unblurred/opaque/settled the
  // text is tracks scroll position directly (not a fixed-duration one-shot
  // transition), same rAF-driven pattern as the material-cards scale/rotate
  // effect above. Runway is deliberately short enough to fully resolve
  // while the section is still comfortably in view — title and body each
  // get their own progress window within it so the body visibly lags
  // behind the title, but both must be fully sharp well before the section
  // scrolls out and the material cards take over.
  var el = document.querySelector('.kp-craft-intro');
  var title = document.querySelector('.kp-craft-intro-title');
  var body = document.querySelector('.kp-craft-intro-body');
  if (!el || !title || !body) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // CSS's own reduced-motion rule (opacity/filter/transform !important) takes over
  }

  function applyProgress(node, p) {
    node.style.opacity = p;
    node.style.filter = 'blur(' + (8 * (1 - p)) + 'px)';
    node.style.transform = 'translateY(' + (20 * (1 - p)) + 'px)';
  }

  var ticking = false;
  var settled = false;

  function update() {
    ticking = false;
    if (settled) return;
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight;
    // raw reaches 1 exactly when rect.bottom (= the cards section's top,
    // they're flush) reaches the viewport's bottom edge — i.e. the instant
    // before the cards section would show even a sliver of itself. That
    // guarantees full resolution strictly before "100% Recycled Polyester
    // Twill" is visible at all. The runway distance itself is NOT just the
    // section's own height, though — on mobile that's short enough (smaller
    // fonts/padding) that the whole reveal completed within a single swipe
    // and read as no animation at all. Floor it to a minimum so there's
    // always a perceptible scroll distance, on any breakpoint.
    var runway = Math.max(rect.height, 750);
    var raw = 1 - Math.max(0, rect.bottom - vh) / runway;
    raw = Math.max(0, Math.min(1, raw));
    var titleP = Math.max(0, Math.min(1, raw / 0.45));
    var bodyP = Math.max(0, Math.min(1, (raw - 0.3) / 0.7));
    applyProgress(title, titleP);
    applyProgress(body, bodyP);
    if (raw >= 1) settled = true;
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
